import { render } from "./information-block.vue?vue&type=template&id=2103a99e&scoped=true&ts=true"
import script from "./information-block.vue?vue&type=script&lang=ts"
export * from "./information-block.vue?vue&type=script&lang=ts"

import "./information-block.vue?vue&type=style&index=0&id=2103a99e&lang=scss&scoped=true"

import exportComponent from "E:\\Build\\vsts-agent-win-x64-4.268.0\\_work\\1\\s\\Connect\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2103a99e"]])

export default __exports__